module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_021.png
// module id = 2368
// module chunks = 5